define ([
	"jquery",
	"wcs.mini-list",
	"wcs.context",
	"wcs.alert",
	"promise!wcs.lang-msg",
	"pubsub"
	], function($, miniList, ctx, alerts){

	var validateAddToCart = function($target){
		$target.parent('.product-form-js section.selection-js').each(function() {
			if(!$(this).hasClass('attribute-value-selected')){
				return false;
			}
		});
		return true;
	};
	var shopTheLookCheck = function(){
		var shopTheLookCheck = $('body').find('.stl-intro-section'),
			displayNotifcation = true;
		
		if(shopTheLookCheck.length){
			$addToBagBtn = $('#quickview-box #product-form .product-actions .button');
							
			$addToBagBtn.addClass('success-message');
			$addToBagBtn.text(STORETEXT.ITEMADDED);
			
			setTimeout(function(){
				$addToBagBtn.text(STORETEXT.ADDTOCART);
				$addToBagBtn.removeClass('success-message');
				},3000);
			displayNotifcation = false;
		}
		
		return displayNotification;
	};
	var shopcartUpdateCheck = function() {	
		$('body').on('click','.add-to-bag-js',function(event){
			var displayNotifcation = true;

			if(validateAddToCart($(event.target))){
				displayNotification = shopTheLookCheck();
				return displayNotifcation;
			}	
		});
	};
	var init = function(callBack){
		if (callBack){
			callBack ();
		}
	};
	return{
		init : init,
		shopcartUpdateCheck : shopcartUpdateCheck
	};
});